/**
 * Returns the current subdirectory ('epos', 'kitchen', etc.).
 *
 * @return {string}
 */
const getSubdirectory = () => {
    return window.location.pathname.split('/')[1] || '';
};

module.exports = {
    getSubdirectory,
};
